go-dropdown {
  /**
    @prop --dropdown-shadow:
      Box shadow of dropdown
      - default: var(--shadow-3)
  */
  --dropdown-shadow: var(--shadow-3);
  /**
    @prop --dropdown-bg-color:
      Dropdown background color
      - default: var(--go-color-lightest)
  */
  --dropdown-bg-color: var(--go-color-lightest);

  /**
    @prop --dropdown-duration:
      Duration for dropdown open/close transition
      - default: var(--go-duration-fast)
  */
  --dropdown-duration: var(--go-duration-fast);

  /**
    @prop --dropdown-radius:
      Border radius of dropdown
      - default: var(--radius-2)
  */
  --dropdown-radius: var(--radius-2);

  position: fixed;
  display: none;
  visibility: hidden;
  opacity: 0;
  box-shadow: var(--dropdown-shadow);
  pointer-events: none;
  z-index: 1;
  transform: translateY(-5px);
  transform-origin: top;
  width: var(--dropdown-width, 200px);
  background-color: var(--dropdown-bg-color);
  border-radius: var(--dropdown-radius);
  @include transition(opacity var(--dropdown-duration), visibility, transform var(--dropdown-duration));
  &.full-width {
    --dropdown-width: 100%;
  }
  &.flip {
    transform-origin: bottom;
    transform: translateY(5px);
  }

  &.is-active {
    visibility: visible;
    opacity: 1;
    pointer-events: inherit;
    transform: translateY(0);
  }
}
